(function () {
  'use strict';

  function removeBundleGroup(groupEl) {
    var removeButtons = Array.from(
      groupEl.querySelectorAll(
        'cart-remove-button[data-key], main-cart-remove-button[data-key]'
      )
    );
    if (!removeButtons.length) return;

    // Collect unique keys → single updates object
    var seen = {};
    var updates = {};
    removeButtons.forEach(function (btn) {
      var key = btn.dataset.key;
      if (!key || seen[key]) return;
      seen[key] = true;
      updates[key] = 0;
    });
    if (Object.keys(updates).length === 0) return;

    var handler = removeButtons[0];
    var removeBtn = groupEl.querySelector('[data-juo-remove-bundle]');
    if (removeBtn) removeBtn.disabled = true;

    // Get sections list from the handler so Shopify returns fresh section HTML
    var sections = [];
    if (typeof handler.getSectionsToRender === 'function') {
      sections = handler.getSectionsToRender().map(function (s) { return s.section; });
    }

    // Single atomic removal — avoids the sequential /cart/change race that
    // produces "geen geldige ID of regelnummer" on the 2nd+ item.
    fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({
        updates: updates,
        sections: sections,
        sections_url: window.location.pathname
      })
    })
    .then(function (res) { return res.json(); })
    .then(function (parsedState) {
      if (parsedState.errors) {
        console.error('[juo-bundle-cart] remove error', parsedState.errors);
        if (removeBtn) removeBtn.disabled = false;
        return;
      }
      if (
        typeof handler.updateCartDrawer === 'function' &&
        handler.cart &&
        handler.cart.classList.contains('cart-drawer')
      ) {
        handler.updateCartDrawer(parsedState);
      } else if (
        typeof handler.updateMainCart === 'function' &&
        handler.cart &&
        handler.cart.classList.contains('main-cart')
      ) {
        handler.updateMainCart(parsedState);
      } else {
        window.location.reload();
      }
    })
    .catch(function () {
      if (removeBtn) removeBtn.disabled = false;
      window.location.reload();
    });
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-juo-remove-bundle]');
    if (!btn) return;
    e.stopPropagation();
    e.preventDefault();
    var group = btn.closest('.juo-bundle-group');
    if (group) removeBundleGroup(group);
  });
})();
